<form [formGroup]="HomeFieldServiceForm" novalidate>
  <section class="content">
    <div class="row">
      <div class="box box-primary">

        <PageHeader   [showNote]="false" (addNoteClick)="notesVisitPurposePlus.AddNote()"
          [showAddNew]="false" [showSearch]="false" [mainlisturl]="ListURL" [showSave]="blnshowSave"
          (SaveEvent)="executeHomeFieldServiceCreateUpdate('')" [showDelete]="blnshowDelete"
          (DeleteEvent)="DeleteEvent()" #pageheader>
        </PageHeader>
        <div class="box">
          <div class="box-body">
            <div class="row">
              <div class="col-sm-12 box-row hidden">
                <label class="col-sm-2 control-label">HFServiceId</label>

                <div class="col-sm-10">
                  <input type="text" readonly class="form-control" name="HFServiceId" [value]="f.HFServiceId"
                    formControlName="HFServiceId">
                </div>
              </div>
              <div class="box ibox box-info  margin-bottom-none">
                <div class="box-body">
                  <div class="col-sm-12 box-row">
                    <div class="col-sm-4">
                      <label class="col-sm-6 control-label">Event ID:</label>
                      <div class="col-sm-6">
                        <label class="readOnlyText"> {{HFServiceCode}} {{MasterHFSCodes ? "/ " + MasterHFSCodes : ""}}  </label>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <label class="col-sm-6 control-label">Form Date:</label>
                      <div class="col-sm-6">
                        <label class="readOnlyText"> {{f.HFServiceCreatedOn.value | date:'dd/MM/yyyy HH:mm'}}</label>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <label class="col-sm-6 control-label">Created By:</label>
                      <div class="col-sm-6">
                        <label class="readOnlyText"> {{UserName}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="box-body box ibox box-info">
                <div class="panel panel-default margin-bottom-none">
                  <div style="padding: 6px 0px;"
                    [ngClass]="{'panel-heading-blue': isBluePanelSection1==true,'panel-heading': isBluePanelSection1==false}"
                    role="tab">
                    <h4 class="panel-title row">
                      <div class="col-sm-10 hfspanel" >
                      <a class="collapsed" data-parent="#accordion" [attr.aria-expanded]="isCollapsed.Section1"
                        aria-controls="HFS_Section1Ref" (click)="ExpandSection('Section1')">
                        <div class="box-header with-border">
                          <h3 class="box-title container col-sm-3">Purpose Detail
                         
                          </h3>
                          <h3 class="box-title container text-center col-sm-8">
                            <b> {{MRMHomeStationName}} </b> <b *ngIf="MRMHomeStationName!='' && f.HFServiceVisitPurpose.value!=''"> - </b><b *ngIf="f.HFServiceVisitPurpose.value!=''">
                              ({{f.HFServiceVisitPurpose.value}})</b>
                          </h3>
                        </div>
                      </a>
                    </div>
                    <div class="col-sm-2 panel-header-icons-end inline">
                      <i class="fa fa-id-card" content-type="template" placement="left" style="margin-right:10px !important; font-size: 22px;"
                         *ngIf="this.f.HFServiceStationId.value && this.f.HFServiceStationId.value !== 'Add New'"></i>
                      <i class="fa fa-check panel-header-icon-success" style="margin-right:6px !important"
                         *ngIf="f.HFServiceVisitDetailsEnteredOn.value"></i>
                    </div>
                    </h4>
                  </div>

                  <ng-template #HtmlContent>
                    <div class="col-sm-12" style="padding:0px">
                      <div class="col-sm-3 text-right">
                        <strong>Address:</strong>
                      </div>
                      <div class="col-sm-offset-1 col-sm-8 text-left">
                        <p>{{ISV_Address}}, {{ISV_City}}, {{ISV_State}}, {{ISV_ZipCode}}</p>
                      </div>
                    </div>
                    <div class="col-sm-12" style="padding:0px">
                      <div class="col-sm-3 text-right">
                        <strong>Phone#:</strong>
                      </div>
                      <div class="col-sm-offset-1 col-sm-8 text-left">
                        <p>{{ISV_Phone}}</p>
                      </div>
                    </div>
                    <div class="col-sm-12" style="padding:0px">
                      <div class="col-sm-3 text-right">
                        <strong>Direction:</strong>
                      </div>
                      <div class="col-sm-offset-1 col-sm-8 text-left">
                        <p>{{ISV_Direction}}</p>
                      </div>
                    </div>

                    <!-- <strong>City:</strong><p>Kitchener</p>
                    <strong>Province:</strong><p>Ontario</p>
                    <strong>Postal Code:</strong><p>L7L2L8</p>
                    <strong>Phone#:</strong><p>416-318-3333</p>
                    <strong>Special Direction:</strong><p>Park on North side of street</p> -->
                  </ng-template>
                  <div id="HFS_Section1" [ngbCollapse]="!isCollapsed.Section1" class="panel-collapse collapse"
                    role="tabpanel" aria-labelledby="HFS_Section1">
                    <div class="box-body">
                      <div class="row">
                        <div class="box-row col-sm-12">
                          <div class="col-sm-6">
                            <label class="col-sm-5 control-label">Home Unit:</label>
                            <div class="col-sm-5" *ngIf="f.HFServiceId.value > 0">
                              <label class="readOnlyText"> {{MRMHomeStationName}}</label>
                            </div>
                            <div class="col-sm-5"
                              *ngIf="f.HFServiceId.value == 0 && f.HFServiceVisitPurpose.value!='Initial Site Visit'">
                              <select class="form-control mdInput" formControlName="HFServiceStationId"
                                (change)="homeUnitChange()">
                                <option value="">Select</option>
                                <option value="Add New">Add New</option>
                                <option [value]="item.dialysisUnitId.toString()" *ngFor="let item of dialysisStations">
                                  {{ item.dialysisStationName }}
                                </option>

                              </select>
                              <span
                                *ngIf="f.HFServiceStationId.errors?.required && (f.HFServiceStationId.dirty || f.HFServiceStationId.touched ||  formSubmitted)"
                                [ngClass]="'error'">Required!</span>
                                <span  *ngIf="f.HFServiceStationId.errors?.IsHFSStationAvailable" [ngClass] = "'error'">
                                  You cannot start a new HFS, while there is an open HFS still existing in the system with same Station.
                                </span>
                            </div>
                            <div class="col-sm-3"
                              *ngIf="f.HFServiceId.value == 0 && f.HFServiceVisitPurpose.value=='Initial Site Visit'">
                              <input class="form-control" [(ngModel)]="nextStationIdPrefix" disabled
                                [ngModelOptions]="{standalone: true}">

                            </div>
                            <div class="col-sm-2"
                              *ngIf="f.HFServiceId.value == 0 && f.HFServiceVisitPurpose.value=='Initial Site Visit'"
                              style="max-width:133px">
                              <input class="form-control" formControlName="HFServiceStationName" type="text"
                                (keyup)="forceInputUppercase($event)" (keypress)="charOnly($event)" maxlength="3" placeholder="XXX">
                                <span
                                *ngIf="f.HFServiceStationName.errors?.required && (f.HFServiceStationName.dirty || f.HFServiceStationName.touched ||  formSubmitted)"
                                [ngClass]="'error'" style="    line-height: 30px;margin: 0;">Required!</span>
                            </div>
                            <div class="col-sm-1 row" *ngIf="f.HFServiceId.value == 0 && f.HFServiceVisitPurpose.value=='Initial Site Visit'">
                                <a href="javascript:void(0)" title="XXX - First Letter of Patient First Name, and First Two Letters of Patient Last Name"><i class="fa fa-info-circle" style="color: black;margin-top: 8px;cursor: pointer;font-size: 20px"></i></a>
                            </div>

                          </div>
                          <div class="col-sm-6">
                            <label class="col-sm-5 control-label">Site Visit Purpose:</label>
                            <div class="col-sm-7" *ngIf="f.HFServiceId.value > 0">
                              <label class="readOnlyText"> {{f.HFServiceVisitPurpose.value}}</label>
                            </div>
                            <div class="col-sm-7" *ngIf="f.HFServiceId.value == 0">
                              <input formControlName="HFServiceVisitPurpose" class="form-control mdInput" *ngIf="f.HFServiceVisitPurpose.value =='Initial Site Visit'" disabled="disabled">
                              <select class="form-control mdInput" formControlName="HFServiceVisitPurpose"
                                (change)="visitPurposeChange()" *ngIf="f.HFServiceVisitPurpose.value !='Initial Site Visit'" >
                                <option value="{{item.value}}" *ngFor="let item of visitPurposeFinalList">
                                  {{item.text}}
                                </option>
                              </select>
                              <span
                                *ngIf="f.HFServiceVisitPurpose.errors?.required && (f.HFServiceVisitPurpose.dirty || f.HFServiceVisitPurpose.touched ||  formSubmitted)"
                                [ngClass]="'error'">
                                Required!
                              </span>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <span class="col-sm-offset-5 col-sm-7" style="color:red;font-size: 12px;"
                                *ngIf="f.HFServiceStationId.value && (ISV_DMEquipment == null || ISV_ROEquipment == null)">{{ISV_Error}}</span>
                          </div>

                        </div>
                        <div class="box-row col-sm-12" *ngIf="f.HFServiceVisitPurpose.value=='Maintenance & Testing'">
                          <div class="col-sm-6">
                            <label class="col-sm-5 control-label">Maintenance & Testing Type:</label>
                            <div class="col-sm-5" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                              <select class="form-control mdInput" formControlName="HFServiceCategory">
                                <option value="{{item.value}}" *ngFor="let item of maintenanceCategories">
                                  {{item.text}}
                                </option>
                              </select>
                              <span
                                *ngIf="f.HFServiceCategory.errors?.required && (f.HFServiceCategory.dirty || f.HFServiceCategory.touched ||  formSubmitted)"
                                [ngClass]="'error'">Required!</span>
                            </div>
                            <div class="col-sm-5" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                              <label class="readOnlyText">{{f.HFServiceTaskCategory.value ? f.HFServiceTaskCategory.value : f.HFServiceCategory.value}}</label>
                            </div>
                          </div>
                        </div>
                        <div class="box-row col-sm-12" *ngIf="f.HFServiceVisitPurpose.value=='Equipment Exchange'">
                          <div class="col-sm-6">
                            <label class="col-sm-5 control-label">Equipment Exchange Type:</label>
                            <div class="col-sm-5" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                              <select class="form-control mdInput" formControlName="HFServiceCategory"
                                (change)="EquipmentCategoryChange()">
                                <option value="{{ (item.text) == 'Select' ? '' : item.text }}"
                                  *ngFor="let item of EquipmentExchangeCategoryList">
                                  {{item.text}}
                                </option>
                              </select>
                              <span
                                *ngIf="f.HFServiceCategory.errors?.required && (f.HFServiceCategory.dirty || f.HFServiceCategory.touched ||  formSubmitted)"
                                [ngClass]="'error'">Required!</span>
                            </div>
                            <div class="col-sm-5" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                              <label class="readOnlyText">{{f.HFServiceTaskCategory.value ? f.HFServiceTaskCategory.value : f.HFServiceCategory.value}}</label>
                            </div>
                          </div>
                        </div>
                       <div class="box-row col-sm-12" *ngIf="f.HFServiceVisitPurpose.value=='Repair'">
                          <div class="col-sm-6">
                            <label class="col-sm-5 control-label">Repair Type:</label>
                            <div class="col-sm-5" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                              <select class="form-control mdInput" formControlName="HFServiceCategory"
                                (change)="EquipmentCategoryChange()">
                                <option value="{{item.text}}" *ngFor="let item of RepairCategoryList">
                                  {{item.text}}
                                </option>
                              </select>
                              <span
                                *ngIf="f.HFServiceCategory.errors?.required && (f.HFServiceCategory.dirty || f.HFServiceCategory.touched ||  formSubmitted)"
                                [ngClass]="'error'">Required!</span>
                            </div>
                            <div class="col-sm-5" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                              <label class="readOnlyText">{{f.HFServiceCategory.value}}</label>
                            </div>
                          </div>
                        </div>
                        <div class="box-row col-sm-12" *ngIf="f.HFServiceVisitPurpose.value=='Repair'">
                          <label class="col-sm-1 control-label" style="width: 21%">Issue:</label>
                          <div class="col-sm-8" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                            <textarea autosize class="form-textarea" formControlName="HFServiceIssue"></textarea>
                            <span
                              *ngIf="f.HFServiceIssue.errors?.required && (f.HFServiceIssue.dirty || f.HFServiceIssue.touched ||  formSubmitted)"
                              [ngClass]="'error'">Required!</span>
                          </div>
                          <div class="col-sm-10" style="width: 72.7%;word-break: break-word;" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                            <label class="readOnlyText">{{f.HFServiceIssue.value}}</label>
                          </div>
                        </div>
                           <div class="box-row col-sm-12" *ngIf="f.HFServiceVisitPurpose.value=='Other'">
                          <label class="col-sm-1 control-label" style="width: 21%">Note:</label>
                          <div class="col-sm-8" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                            <textarea autosize class="form-textarea" rows="2" formControlName="OtherNote"></textarea>
                            <span
                              *ngIf="f.OtherNote.errors?.required && (f.OtherNote.dirty || f.OtherNote.touched ||  formSubmitted)"
                              [ngClass]="'error'">Required!</span>
                          </div>
                          <div class="col-sm-10" style="width: 72.7%;word-break: break-word;" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                            <label class="readOnlyText">{{f.HFServiceIssue.value}}</label>
                          </div>
                        </div>
                        <div class="box-row col-sm-12" *ngIf="f.HFServiceVisitPurpose.value=='Initial Site Visit'">
                          <div class="col-sm-6">
                            <label class="col-sm-5 control-label">Address:</label>
                            <div class="col-sm-6" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                              <textarea autosize class="form-textarea mdInput" formControlName="ISVAddress"></textarea>
                            </div>
                            <span
                              *ngIf="f.ISVAddress.errors?.required && (f.ISVAddress.dirty || f.ISVAddress.touched ||  formSubmitted)"
                              [ngClass]="'error'" style="    margin: -14px;padding: 0;">Required!</span>
                            <div class="col-sm-7" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                              <label class="readOnlyText">{{f.ISVAddress.value}}</label>
                            </div>
                          </div>

                          <div class="col-sm-6">
                            <label class="col-sm-5 control-label">City:</label>
                            <div class="col-sm-7" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                              <input class="form-control mdInput" formControlName="ISVCity">
                              <span
                                *ngIf="f.ISVCity.errors?.required && (f.ISVCity.dirty || f.ISVCity.touched ||  formSubmitted)"
                                [ngClass]="'error'">Required!</span>
                            </div>
                            <div class="col-sm-7" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                              <label class="readOnlyText">{{f.ISVCity.value}}</label>
                            </div>
                          </div>
                        </div>
                        <div class="box-row col-sm-12" *ngIf="f.HFServiceVisitPurpose.value=='Initial Site Visit'">
                          <div class="col-sm-6">
                            <label class="col-sm-5 control-label">Province:</label>
                            <div class="col-sm-7" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                              <input class="form-control mdInput" formControlName="ISVProvince">
                            </div>
                            <div class="col-sm-7" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                              <label class="readOnlyText">{{f.ISVProvince.value}}</label>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <label class="col-sm-5 control-label">Postal Code:</label>
                            <div class="col-sm-7" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                              <input class="form-control mdInput" formControlName="ISVPostalCode" maxlength="7"
                                (keyup)="forceInputUppercase($event)" placeholder="A0A 0A0" (focusout)="lostfocusPostalCode()">
                              <span *ngIf='f.ISVPostalCode.errors?.pattern' [ngClass]="'error'" style="margin-left: 2px;">Invalid value</span>
                              <span
                                *ngIf="f.ISVPostalCode.errors?.required && (f.ISVPostalCode.dirty || f.ISVPostalCode.touched ||  formSubmitted)"
                                [ngClass]="'error'">Required!</span>
                            </div>
                            <div class="col-sm-7" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                              <label class="readOnlyText">{{f.ISVPostalCode.value}}</label>
                            </div>
                          </div>
                        </div>
                        <div class="box-row col-sm-12" *ngIf="f.HFServiceVisitPurpose.value=='Initial Site Visit'">
                          <div class="col-sm-6">
                            <label class="col-sm-5 control-label">Phone #:</label>
                            <div class="col-sm-7" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                              <input class="form-control mdInput" (keypress)="numberOnly($event)" maxLength="15"
                                placeholder="(###) ###-####" (blur)="formatPhone('phone')"
                                formControlName="ISVPhoneNumber">
                              <span
                                *ngIf="f.ISVPhoneNumber.errors?.required && (f.ISVPhoneNumber.dirty || f.ISVPhoneNumber.touched ||  formSubmitted)"
                                [ngClass]="'error'">Required!</span>
                              <span *ngIf='f.ISVPhoneNumber.errors?.pattern' [ngClass]="'error'"
                                style="margin-left: 2px;">Invalid value</span>
                            </div>
                            <div class="col-sm-7" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                              <label class="readOnlyText">{{f.ISVPhoneNumber.value}}</label>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <label class="col-sm-5 control-label">Access Code:</label>
                            <div class="col-sm-7" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                              <input class="form-control mdInput" maxLength="15" placeholder=""
                                formControlName="ISVAccessCode">

                            </div>
                            <div class="col-sm-7" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                              <label class="readOnlyText">{{f.ISVAccessCode.value}}</label>
                            </div>
                          </div>
                        </div>
                        <div class="box-row col-sm-12" *ngIf="f.HFServiceVisitPurpose.value=='Initial Site Visit'">
                          <label class="col-sm-2 control-label" style="width: 21.05%;">Directions:</label>
                          <div class="col-sm-9" style="width: 72.6%;word-break: break-word;" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value">
                            <textarea autosize class="form-textarea" formControlName="ISVDirections"></textarea>
                          </div>
                          <span
                            *ngIf="f.ISVDirections.errors?.required && (f.ISVDirections.dirty || f.ISVDirections.touched ||  formSubmitted)"
                            [ngClass]="'error'" style="margin:0">Required!</span>
                          <div class="col-sm-9" style="width: 72.6%;word-break: break-word;" *ngIf="f.HFServiceVisitDetailsEnteredOn.value">
                            <label class="readOnlyText">{{f.ISVDirections.value}}</label>
                          </div>
                        </div>
                        
                        <div class="box-row col-sm-12">
                          <label class="col-sm-1 control-label inputfieldwidth" >
                            Additional Technologist Required:
                          </label>
                          <div class="col-sm-8" *ngIf="!f.HFServiceVisitDetailsEnteredOn.value" style="display: flex; align-items: center; gap: 1rem;">
                            <!-- Boolean toggle group -->
                            <mat-button-toggle-group formControlName="IsAdditionalTechnologistRequired">
                              <mat-button-toggle [value]="false">No</mat-button-toggle>
                              <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                            </mat-button-toggle-group>

                            <!-- Show multiselect only when Yes -->
                            <p-multiSelect *ngIf="f.IsAdditionalTechnologistRequired?.value === true"
                              [options]="TechnologistsList"
                              optionLabel="text"
                              optionValue="text"
                              placeholder="Add More Technologist(s)"
                              display="chip"
                              [filter]="true"
                              formControlName="AdditionalTechnologists"
                              name="AdditionalTechnologists">
                            </p-multiSelect>
                          </div>

                          <div class="col-sm-8" *ngIf="f.HFServiceVisitDetailsEnteredOn.value" style="display: flex; align-items: center; gap: 1rem;">
                              <label class="readOnlyText" *ngIf="!f.IsAdditionalTechnologistRequired.value">No</label>
                              <label class="readOnlyText">{{f.AdditionalTechnologists.value}}</label>
                          </div>

                        </div>

                        <div class="col-sm-12">
                          <notes
                            [isValidForm]="f.HFServiceVisitDetailsEnteredOn.value || this.HomeFieldServiceForm.invalid"
                            #notesVisitPurpose
                            (addNoteClick)="executeHomeFieldServiceCreateUpdate('PurposeDetail',true,f.HFServiceVisitDetailsEnteredOn.value)">
                          </notes>
                        </div>
                        <!-- <div class="col-sm-12" [hidden]="f.HFServiceVisitDetailsEnteredOn.value">
                          <PageHeader [showNote]="false" [showAddNew]="false" [showSearch]="false" [showSave]="true"
                            [showMainListing]="false" (SaveEvent)="executeHomeFieldServiceCreateUpdate('PurposeDetail')"
                            [showDelete]="false" [showCancel]="f.HFServiceVisitPurpose.value == 'Initial Site Visit'" (CancelEvent)="f.HFServiceVisitPurpose.setValue(''); f.HFServiceStationId.setValue(''); f.HFServiceVisitPurpose.enable();" #pageheader>
                          </PageHeader>
                        </div> -->

                        <div class="col-sm-12" [hidden]="f.HFServiceVisitDetailsEnteredOn.value">
                        <div class="text-right" style="margin-bottom: 10px;">
                          <!-- <button
                            type="button"
                            class="btn btn-primary"
                            (click)="executeHomeFieldServiceCreateUpdate('PurposeDetail')">
                            <i class="fa fa-save">Save</i>
                          </button> -->
                           <a href="javascript:void(0)" (click)="executeHomeFieldServiceCreateUpdate('PurposeDetail')" 
                              class="btn btn-primary" 
                              title="Save"> <i class="fa fa-save"></i> &nbsp; <span>Save</span> </a>

                          <a href="javascript:void(0)" *ngIf="f.HFServiceVisitPurpose.value == 'Initial Site Visit'"
                              (click)="
                                f.HFServiceVisitPurpose.setValue('');
                                f.HFServiceStationId.setValue('');
                                f.HFServiceVisitPurpose.enable();" class="btn btn-primary" style="margin-left: 5px;"
                             title="Cancel"> <i class="fa fa-close"></i> &nbsp; <span>Cancel</span> </a>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="clearfix"></div>
              <div class="box-body box ibox box-info">
                <div class="panel panel-default margin-bottom-none">
                  <div class="panel-heading"
                    [ngClass]="{'panel-heading-blue': isBluePanelPurposeDetail==true,'panel-heading': isBluePanelPurposeDetail==false}"
                    role="tab">
                    <h4 class="panel-title row">
                      <div class="col-sm-10 hfspanel" style="cursor: pointer;" (click)="ExpandSection('PurposeDetail')">
                        <a class="collapsed" data-parent="#accordion" [attr.aria-expanded]="isCollapsed.PurposeDetail"
                          aria-controls="HFS_PurposeDetailRef">
                          <div class="box-header with-border" style="padding: 6px 0px;">
                            <h3 class="box-title col-sm-3 container">Prep Detail
                            </h3>
                            <h3 class="col-sm-8 text-center box-title container" *ngIf="f.HFServiceVisitNotificationEnteredOn.value">
                              <b>Total Prep Time : {{totalPrepDetailTime}} Hrs</b>
                            </h3>
                          </div>
                        </a>
                      </div>
                      <div class="col-sm-2 panel-header-icons-end inline ">
                        <!-- <button style="display: inline-block;cursor: pointer;margin-right:4px;" type="button"
                          class="row btn homeFieldBtn"
                          [ngClass]="{'btn-primary':!f.HFServiceVehiclePrepDetailsEnteredOn.value}"
                          tooltip="Add Prep Detail"
                          (click)="OpenPrepDetail()"
                          *ngIf="f.HFServiceVisitDetailsEnteredOn.value && f.HFServicePTHMPurposeCompleted.value != 'Yes'">
                          <span><i class="fa fa-cog"></i>&nbsp; Prep Detail</span>
                        </button> -->
                         <button style="display: inline-block;cursor: pointer;margin-right:4px;" type="button"
                          class="row btn homeFieldBtn"
                          [ngClass]="{'btn-primary':!f.HFServiceVehiclePrepDetailsEnteredOn.value}"
                          tooltip="Add Prep Detail"
                          (click)="OpenPrepDetail()">
                          <span><i class="fa fa-cog"></i>&nbsp; Prep Detail</span>
                        </button>
                             <i class="fa fa-check panel-header-icon-success"
                         *ngIf="f.HFServiceVehiclePrepDetailsEnteredOn.value"></i>
                      </div>
                    </h4>
                  </div>

                  <div id="HFS_PurposeDetail" [ngbCollapse]="!isCollapsed.PurposeDetail" class="panel-collapse collapse"
                    role="tabpanel" aria-labelledby="HFS_PurposeDetail">
                    <div class="box-body">
                      <div class="row" >
                          <div class="row" *ngIf="(f.HFServiceVisitPurpose.value == 'Renovation & Full Installation' ||
                          f.HFServiceVisitPurpose.value == 'Uninstallation') && PrepDetailsList.length > 0" >
                          <div class="col-sm-12 box-row">
                              <div class="col-sm-offset-2 col-sm-4">
                                  <label class="col-sm-5 control-label">PO Plumber:</label>
                                  <div class="col-sm-7">
                                      <label class="readOnlyText" formControlName="poPlumber"> {{f.poPlumber.value}}</label>
                                  </div>
                              </div>
                              <div class="col-sm-4">
                                <label class="readOnlyText" formControlName="poPlumberNote"> {{f.poPlumberNote.value}}</label>
                              </div>
                          </div>
                          <div class="col-sm-12 box-row">
                              <div class="col-sm-offset-2 col-sm-4">
                                  <label class="col-sm-5 control-label">PO Electrician:</label>
                                  <div class="col-sm-7">
                                      <label class="readOnlyText" formControlName="poElectrician"> {{f.poElectrician.value}}</label>
                                  </div>
                              </div>
                              <div class="col-sm-4">
                                <label class="readOnlyText" formControlName="poElectricianNote"> {{f.poElectricianNote.value}}</label>
                              </div>
                          </div>
                          <div class="col-sm-12 box-row">
                              <div class="col-sm-offset-2 col-sm-4">
                                  <label class="col-sm-5 control-label">PO Movers:</label>
                                  <div class="col-sm-7">
                                      <label class="readOnlyText" formControlName="poMovers"> {{f.poMovers.value}}</label>
                                  </div>
                              </div>
                              <div class="col-sm-4">
                                <label class="readOnlyText" formControlName="poMoversNote"> {{f.poMoversNote.value}}</label>
                              </div>
                          </div>
                        </div>
                        <div class="box-row col-sm-9" *ngIf="PrepDetailsList.length > 0">
                          <table style="width:100%" align="center" class="table InnerTable table-responsive">
                            <tr>
                              <th class="InnerTableHead" style="width:8%">
                                Date
                              </th>
                               <th class="InnerTableHead" style="width:7%">
                                Time
                              </th>
                              <th class="InnerTableHead"  style="width:14%">
                                Prep Time(Hr.)
                              </th>
                              <th class="InnerTableHead" style="width:15%">
                                Technologist(s)
                              </th>
                              <th class="InnerTableHead" style="width:61%;text-align: left !important;">
                                Notes
                              </th>

                            </tr>
                            <tbody *ngFor="let item of PrepDetailsList;let index=index;">
                              <tr>
                                <td class="p-0">
                                  {{item.prepDate | date:'dd/MM/yyyy'}}
                                </td>
                                 <td  class="p-0">
                                  {{item.prepDate | date:'hh:mm'}}
                                </td>
                                <td class="p-0">
                                  {{item.prepTime}}
                                </td>
                                <td  class="p-0" title="{{item.prepTechnologists}}">
                                  {{item.createdByName}} <span *ngIf="item.prepTechnologists!=''" >+{{techCount(item.prepTechnologists)}}</span>
                                </td>
                                <td  class="text-left p-0">
                                    <div class="break-words">
                                  {{item.prepNotes}}
                                </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-sm-3" *ngIf="f.HFServiceVehiclePrepDetailsEnteredOn.value">
                                <div class="panel panel-default" style="padding:2px !important;margin-bottom: 0px !important;">
                                  <!-- Label on first line -->
                                  <label class="control-label" style="padding: 6px 12px; padding-bottom: 0px!important;">Spoke with Pt. about Visit:</label>

                                  <!-- Value on second line, shown only if conditions are met -->
                                    <label class="readOnlyText" *ngIf="f.HFServiceVisitNotification.value === 'Spoke' && f.HFServicelastModifiedSection.value !== 'Pending'">
                                      {{ f.HFServiceVisitNotificationEnteredOn.value | date: 'dd/MM/yyyy HH:mm' }}
                                    </label>
                                    <label class="readOnlyText " *ngIf="f.HFServiceVisitNotification.value === 'Spoke' && f.HFServicelastModifiedSection.value !== 'Pending'">
                                      {{ CurrentUser }}
                                    </label>
                                </div>
                              </div>
                        <!-- <div class="box-row col-sm-12" style="margin-top:20px;">
                          <div class="col-sm-6" style="margin-top: 5px;">
                            <span
                            *ngIf="f.HFServiceVehiclePrepTime.errors?.required && (f.HFServiceVehiclePrepTime.dirty || f.HFServiceVehiclePrepTime.touched ||  formSubmitted)"
                            [ngClass]="'error'" style="font-size: 14px;">Atleast one Prep Detail entry is required.</span>

                          </div>

                         </div> -->

                        <div class="col-sm-9">
                          <notes
                            #notesVisitPrep
                            (addNoteClick)="executeHomeFieldServiceCreateUpdate('PrepDetail',true,f.HFServiceVehiclePrepDetailsEnteredOn.value)">
                          </notes>
                        </div>
                     
                        <div class="col-sm-12">
                          <!-- <PageHeader [showNote]="false" [showAddNew]="false" [showSearch]="false" [showSave]="true"
                            [showMainListing]="false" (SaveEvent)="executeHomeFieldServiceCreateUpdate('PrepDetail')"
                            [showDelete]="false" #pageheader>
                          </PageHeader> -->

                          <!-- <div class="col-sm-12" *ngIf="f.HFServiceVehiclePrepDetailsEnteredOn.value">
                            <label class="text-right col-sm-8 control-label">Spoke with Pt. about Visit:</label>
                            <div class="col-sm-4" *ngIf="f.HFServiceVehiclePrepDetailsEnteredOn.value && f.HFServiceVisitNotification.value ==='Spoke' && f.HFServicelastModifiedSection.value !== 'Pending'">
                              <label class="readOnlyText"> {{f.HFServiceVisitNotificationEnteredOn.value | date:'dd/MM/yyyy HH:mm'}}</label>
                              <label class="readOnlyText"> {{CurrentUser}} </label>
                            </div>
                          </div> -->
                          <div
                            *ngIf="!f.HFServiceVehiclePrepDetailsEnteredOn.value"
                            style="width: 100%; display: flex; justify-content: flex-end;"
                          >
                            <div style="display: flex; align-items: center; gap: 12px;">

                              <label class="control-label" style="margin: 0;">
                                Spoke with Pt. about Visit:
                              </label>

                              <mat-checkbox (change)="OnVisitNotificationChange($event)"></mat-checkbox>

                              <button
                                style=" display: table;margin: 0; padding: 4px 8px;border:1px solid black;" class="btn"
                                (click)="OpenQuestionList()"
                                tooltip="Pre-Visit Safety Assessment"
                                
                              >
                                <i class="fa fa-list"></i>
                              </button>

                              <span
                                *ngIf="f.HFServiceVisitNotification.errors?.required &&
                                      (f.HFServiceVisitNotification.dirty || 
                                        f.HFServiceVisitNotification.touched || 
                                        formSubmitted)"
                                class="error"
                              >
                                Required!
                              </span>

                            </div>
                          </div>
                          <div class="col-sm-12" style="display: flex; justify-content: flex-end;">
                            <button
                              type="button"
                              class="btn btn-primary"
                              *ngIf="f.HFServiceVisitNotification.value && f.HFServiceVisitNotification.value !== '' && !f.HFServiceVehiclePrepDetailsEnteredOn.value && PrepDetailsList.length > 0"
                              (click)="executeHomeFieldServiceCreateUpdate('PrepDetail')"
                            >
                              <i class="fa fa-save"></i>&nbsp; Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="clearfix"></div>
              <div class="box-body box ibox box-info">
                <div class="panel panel-default margin-bottom-none">
                  <div class="panel-heading"
                    [ngClass]="{'panel-heading-blue': isBluePanelPrepDetail==true,'panel-heading': isBluePanelPrepDetail==false}"
                    title="{{ (f.HFServiceVehiclePrepDetailsEnteredOn.value && f.HFServiceVisitNotification.value !=='Spoke') ? 'Change Visit Notification to Spoke to Enter Vehicle Detail' : ''}}"
                    role="tab">
                    <h4 class="panel-title row">
                      <div class="col-sm-10 hfspanel"  style="cursor: pointer;" (click)="ExpandSection('PrepDetail')">
                        <a class="collapsed" data-parent="#accordion" [attr.aria-expanded]="isCollapsed.PrepDetail"
                          aria-controls="HFS_PrepDetailRef">
                          <div class="box-header with-border" style="padding: 6px 0px;">
                            <h3 class="box-title col-sm-3 container">Vehicle Detail
                            </h3>
                            <h3 class="col-sm-8 text-center box-title container">
                              <b *ngIf="VehicleListSummary!==''" >Vehicle List : {{VehicleListSummary}}</b>
                            </h3>

                          </div>
                        </a>
                      </div>
                      <div class="col-sm-2 panel-header-icons-end inline" style="text-align:right">
                        <!-- <button *ngIf="isAdditionalAddVehicle" style="display: inline-block;cursor: pointer;"
                          tooltip="Add Vehicle Detail" (click)="OpenVehicleDetail()"
                          class="btn btn-primary  no-print btn-label-left center-block btn-xs" type="button">
                          <span><i class="fa fa-plus"></i></span>
                        </button> -->
                        <button *ngIf="isAdditionalAddVehicle" style="display: inline-block;cursor: pointer;margin-right: 4px;" type="button" class="row btn btn-primary homeFieldBtn"
                        tooltip="Add Vehicle Detail" (click)="OpenVehicleDetail()">
                        <i class="fa fa-truck"></i> &nbsp; Vehicle Detail</button>
                         <i class="fa fa-check panel-header-icon-success"
                         *ngIf="!isAdditionalAddVehicle"></i>
                      </div>
                    </h4>
                  </div>

                  <div id="HFS_PrepDetail" [ngbCollapse]="!isCollapsed.PrepDetail" class="panel-collapse collapse"
                    role="tabpanel" aria-labelledby="HFS_PrepDetail">
                    <div class="box-body">
                      <div class="row">
                             <!-- Right Side: Vehicle Info -->
                          <div *ngIf="VehicleDetailsList && VehicleDetailsList?.length > 1">
                              <div class="col-sm-12" *ngIf="getVehicleList()">
                              
                              <div *ngFor="let item of VehicleDetailsList; let index=index;" class="panel panel-default mb-2 col-sm-3" style="margin-left:10px;padding-left: 0px !important;padding-right: 0px !important;">
                                <div style="background-color: lightgray; padding: 4px 8px;text-align: center;">
                                <label style="color: black; margin: 0;">T{{ index + 1 }}</label>
                              </div>
                                <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">Vehicle:</label>
                                    <span>{{ item.hfServiceVehicleName }}</span>
                                  </div>

                                  <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">Inspection:</label>
                                    <span>{{ item.hfServiceVehicleInspectionStatus ? 'All Passed' : 'Failures Noted' }}</span>
                                  </div>

                                  <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">Start KM:</label>
                                    <span>{{ item.hfServiceVehicleStartedKM }}</span>
                                  </div>

                                  <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">End KM:</label>
                                    <span>{{ item.hfServiceVehicleEndedKM }}</span>
                                  </div>

                                  <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">Start Time:</label>
                                    <span>{{ item.hfServiceVehicleStartTime | date:'dd/MM/yyyy HH:mm' }}</span>
                                  </div>

                                  <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">End Time:</label>
                                    <span>{{ item.hfServiceVehicleEndTime | date:'dd/MM/yyyy HH:mm' }}</span>
                                  </div>
                              </div>
                          </div>
                          </div>

                             <div class="col-sm-9">
                              <notes
                                #notesVisitVehicles
                                (addNoteClick)="executeHomeFieldServiceCreateUpdate('VehicleDetail',true,f.HFServiceVehicleDetailsEnteredOn.value)">
                              </notes>
                            </div>

                            <div class="col-sm-3" *ngIf="!VehicleDetailsList || VehicleDetailsList.length <= 1">
                              <div *ngFor="let item of VehicleDetailsList" class="panel panel-default mb-2">
                                  <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">Vehicle:</label>
                                    <span>{{ item.hfServiceVehicleName }}</span>
                                  </div>

                                  <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">Inspection:</label>
                                    <span>{{ item.hfServiceVehicleInspectionStatus ? 'All Passed' : 'Failures Noted' }}</span>
                                  </div>

                                  <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">Start KM:</label>
                                    <span>{{ item.hfServiceVehicleStartedKM }}</span>
                                  </div>

                                  <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">End KM:</label>
                                    <span>{{ item.hfServiceVehicleEndedKM }}</span>
                                  </div>

                                  <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">Start Time:</label>
                                    <span>{{ item.hfServiceVehicleStartTime | date:'dd/MM/yyyy HH:mm' }}</span>
                                  </div>

                                  <div class="mb-2">
                                    <label class="control-label fixed-label-vehicle">End Time:</label>
                                    <span>{{ item.hfServiceVehicleEndTime | date:'dd/MM/yyyy HH:mm' }}</span>
                                  </div>
                              </div>
                            </div>
                       
                        <div class="row text-right col-sm-12" [hidden]="f.HFServiceVehicleDetailsEnteredOn.value">
                          <!-- <PageHeader [showNote]="false" [showAddNew]="false" [showSearch]="false" [showSave]="true"
                            [showMainListing]="false" (SaveEvent)="executeHomeFieldServiceCreateUpdate('VehicleDetail')"
                            [showDelete]="false" #pageheader>
                          </PageHeader> -->
                          <!-- <button type="button" class="row btn btn-primary"
                            (click)="executeHomeFieldServiceCreateUpdate('VehicleDetail')">
                            <i class="fa fa-truck"></i> &nbsp; Vehicle Detail</button> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="clearfix"></div>
              <div class="box-body box ibox box-info">
                <div class="panel panel-default margin-bottom-none">
                  <div class="panel-heading"
                    [ngClass]="{'panel-heading-blue': isBluePanelVehicleDetail==true,'panel-heading': isBluePanelVehicleDetail==false}"
                    role="tab">
                    <h4 class="panel-title row">
                      <div class="col-sm-10 hfspanel" style="cursor:pointer" (click)="ExpandSection('VehicleDetail')">
                        <a class="collapsed" data-parent="#accordion" [attr.aria-expanded]="isCollapsed.VehicleDetail"
                          aria-controls="HFS_VehicleDetailRef">
                          <div class="box-header with-border" style="padding: 6px 0px;">
                            <h3 class="box-title col-sm-4 container">Visit Purpose Detail
                              <span *ngIf="otherHFSPurposeList.length > 0"> - Master</span>
                             
                            </h3>
                            <h3 *ngIf="MRMHomeStationName!=''" class="col-sm-6 text-center box-title container">
                              <b>{{MRMHomeStationName}} </b> <b *ngIf="MRMHomeStationName!='' && f.HFServiceVisitPurpose.value!=''"> - </b><b *ngIf="f.HFServiceVisitPurpose.value!=''">
                                ({{f.HFServiceVisitPurpose.value}})</b></h3>
                          </div>
                        </a>
                      </div>
                      <div class="col-sm-2 inline panel-header-icons-end" style="text-align:right">
                        <!-- <button style="display: inline-block;cursor: pointer;" tooltip="Add Departure Detail"
                            (click)="OpenPurposeDetail(true)"
                            *ngIf="isAdditionalAddDeparture"
                            class="btn btn-primary  no-print btn-label-left center-block btn-xs" type="button">
                            <span><i class="fa fa-plus"></i></span>
                        </button> -->

                        <!-- <button style="display: inline-block;cursor: pointer;" tooltip="Add Arrival Detail"
                            (click)="OpenPurposeDetail()"
                            *ngIf="isAdditionalAddArrival"
                            class="btn btn-primary  no-print btn-label-left center-block btn-xs" type="button">
                            <span><i class="fa fa-plus"></i></span>
                        </button> -->

                        <button type="button" class="row btn btn-primary homeFieldBtn" style="margin-right: 4px;"
                           *ngIf="isAdditionalAddDeparture"
                          (click)="OpenPurposeDetail(true)">
                          <i class="fa fa-clock-o"></i> &nbsp; Departure Details</button>

                        <button *ngIf="isAdditionalAddArrival" type="button" class="row btn btn-primary homeFieldBtn" style="margin-right: 4px;"
                          tooltip="Add Arrival Detail" 
                          
                          (click)="OpenPurposeDetail()">
                          <i class="fa fa-clock-o"></i> &nbsp; Arrival Details
                        </button>
                        
                        <i class="fa fa-check panel-header-icon-success"
                         *ngIf="f.HFServicePTHMPurposeCompletedOn.value"></i>

                      </div>
                    </h4>
                  </div>

                  <div id="HFS_VehicleDetail" [ngbCollapse]="!isCollapsed.VehicleDetail" class="panel-collapse collapse"
                    role="tabpanel" aria-labelledby="HFS_VehicleDetail">
                    <div class="box-body">
                      <!-- <div class="box-row col-sm-12" *ngIf="f.HFServicePTHMArrivalTime.value" > -->
                      <div class="box-row col-sm-12">

                        <span class="border border-primary col-sm-12" style="height: auto;text-align:center"
                        *ngIf="f.HFServiceVisitPurpose.value!='Initial Site Visit' &&
                            f.HFServiceVisitPurpose.value!='Uninstallation'">

                          <mat-button-toggle-group [(ngModel)]="purposeSelectedId"
                                                name="purposeSelectedId" style="margin-left:1%"
                                                [ngModelOptions]="{standalone: true}">
                              <mat-button-toggle *ngFor="let item of visitPurposeWithoutRenovationList"
                                    value="{{item.value}}" (change)="purposeSelection(item)" [style.color]="item.isFormSubmitted ? '#4f68e1' : '' ">
                                        {{item.text}}
                              </mat-button-toggle>
                          </mat-button-toggle-group>
                        </span>
                        <!-- <span class="border border-primary col-sm-12" style="height: auto;text-align:center"
                        *ngIf="f.HFServiceVisitPurpose.value=='Renovation & Full Installation'">

                          <mat-button-toggle-group [(ngModel)]="purposeSelectedId"
                                                name="purposeSelectedId" style="margin-left:1%"
                                                [ngModelOptions]="{standalone: true}">
                              <mat-button-toggle *ngFor="let item of visitPurposeRenovationList"
                                    value="{{item.value}}" (change)="purposeSelection(item)" [style.color]="item.isFormSubmitted ? '#4f68e1' : '' ">
                                        {{item.text}}
                              </mat-button-toggle>
                          </mat-button-toggle-group>
                        </span> -->

                        <span class="border border-primary" style="height: auto"
                        *ngIf="f.HFServiceVisitPurpose.value=='Initial Site Visit' ||
                            f.HFServiceVisitPurpose.value=='Uninstallation'">

                          <!-- Add Dynamic Component based on the Purpose-->

                          <PurposeInitialSiteVisit *ngIf="f.HFServiceVisitPurpose.value=='Initial Site Visit'">
                          </PurposeInitialSiteVisit>
                          <!-- <PurposeFullInstallation
                            *ngIf="f.HFServiceVisitPurpose.value=='Renovation & Full Installation'">
                          </PurposeFullInstallation> -->
                          <PurposeUninstallation *ngIf="f.HFServiceVisitPurpose.value=='Uninstallation'">
                          </PurposeUninstallation>

                          <!-- <PurposeUninstallation *ngIf="f.HFServiceVisitPurpose.value=='Uninstallation'">
                          </PurposeUninstallation>
                          <PurposeEquipmentExchange *ngIf="f.HFServiceVisitPurpose.value=='Equipment Exchange'">
                          </PurposeEquipmentExchange>
                          <PurposeTesting *ngIf="f.HFServiceVisitPurpose.value=='Testing'"></PurposeTesting>
                          <PurposeRepair *ngIf="f.HFServiceVisitPurpose.value=='Repair'"></PurposeRepair>
                          <PurposeMaintenance *ngIf="f.HFServiceVisitPurpose.value=='Maintenance & Testing'"
                            (addNoteClick)="executeHomeFieldServiceCreateUpdate('VisitPurposeDetail',true,true)"></PurposeMaintenance>
                          <PurposeOther *ngIf="f.HFServiceVisitPurpose.value=='Other'"></PurposeOther> -->

                          <h3 *ngIf="f.HFServiceVisitPurpose.value==''" class='error'>
                            <!-- Add Dynamic Component based on the Purpose -->
                            <b style="text-decoration: underline;cursor: pointer;" (click)="ExpandSection('Section1')">
                              Select Purpose For First Station...</b>
                          </h3>
                        </span>
                      </div>
                        <!-- <div class="box-body col-sm-12" *ngIf="PurposeDetailsList.length > 0">
                            <table style="width:100%" align="center" class="table InnerTable table-responsive">
                             
                              <tr>
                               
                                <th class="InnerTableHead"  style="width:12%">
                                  Pt. Hm Arrival Time
                                </th>
                                <th class="InnerTableHead"  style="width:12%">
                                  Pt. Hm Dep.Time
                                </th>
                                <th class="InnerTableHead"  style="width:12%">
                                  Purpose Completed?
                                </th>
                                <th class="InnerTableHead"  style="width:64%">
                                  Notes
                                </th>

                              </tr>
                              <tbody *ngFor="let item of PurposeDetailsList;let index=index;">
                                <tr>
                                
                                  <td>
                                    {{item.hfServicePTHMArrivalTime  | date:'dd/MM/yyyy HH:mm'}}
                                  </td>
                                  <td>
                                    {{item.hfServicePTHMDepartureTime  | date:'dd/MM/yyyy HH:mm'}}
                                  </td>
                                  <td>
                                    {{item.hfServicePTHMPurposeCompleted}}
                                  </td>
                                  <td style="text-align: left">
                                    <div class="break-words">
                                    {{item.hfServicePurposeDetailNotes}}
                                  </div>
                                  </td>

                                </tr>
                              </tbody>
                            </table>
                        </div> -->

                     
                        <div class="col-sm-9"  [hidden]="!f.HFServicePTHMArrivalTime.value" >
                        <notes
                          #notesVisitPurposePlus
                          (addNoteClick)="executeHomeFieldServiceCreateUpdate('VisitPurposeDetail',true,true)">
                        </notes>

                        <attachment [category]="'homefieldpurpose_detail'" *ngIf="f.HFServiceVisitPurpose.value!='Repair'" #attachmentVisitPurposePlus
                          id="attachmentVisitPurposePlus" (RaiseError)="AttachmentError($event)">

                        </attachment>
                      </div>
                          <!-- Left column for notes and attachment -->
                          <!-- <div class="col-sm-9">
                            <div class="mb-2">
                              <label class="control-label d-block font-weight-bold">Notes:</label>
                              <div class="break-words">{{ item.hfServicePurposeDetailNotes }}</div>
                            </div>

                            <div class="mt-2" *ngIf="item.attachmentPath">
                              <button class="btn btn-primary btn-xs" (click)="openImageDialog(item.attachmentPath)">
                                <i class="fa fa-paperclip"></i> View Attachment
                              </button>
                            </div>
                          </div> -->
                          <!-- Right column for label-value -->
                          <div class="col-sm-3" *ngIf="PurposeDetailsList.length > 0">
                          <div *ngFor="let item of PurposeDetailsList" class="panel panel-default mb-2" style="padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 5px;">

                            <div class="mb-2">
                              <label class="control-label fixed-label-purpose">Arrival Time:</label>
                              <span>{{ item.hfServicePTHMArrivalTime | date:'dd/MM/yyyy HH:mm' }}</span>
                            </div>

                            <div class="mb-2">
                              <label class="control-label fixed-label-purpose">Departure Time:</label>
                              <span>{{ item.hfServicePTHMDepartureTime | date:'dd/MM/yyyy HH:mm' }}</span>
                            </div>

                            <div class="mb-2">
                              <label class="control-label fixed-label-purpose">Purpose Completed?</label>
                              <span>{{ item.hfServicePTHMPurposeCompleted }}</span>
                            </div>

                             <div class="mb-2">
                              <label class="control-label fixed-label-purpose">Purpose Detail Notes:</label>
                              <span>{{ item.hfServicePurposeDetailNotes }}</span>
                            </div>
                           
                          </div>
                          </div>
                     
                        
                      <div class="text-right col-sm-12">

                        <!-- <button type="button" class="btn btn-primary"
                          *ngIf="isAdditionalAddArrival"  tooltip="Add Arrival Detail"
                          (click)="executeHomeFieldServiceCreateUpdate('VisitPurposeDetail')">
                          <i class="fa fa-clock-o"></i> &nbsp; Arrival Details
                        </button> -->

                          <!-- <button type="button" class="btn btn-primary"
                          *ngIf="isAdditionalAddDeparture"
                          (click)="executeHomeFieldServiceCreateUpdate('VisitPurposeDetail')">
                          <i class="fa fa-clock-o"></i> &nbsp; Departure Details</button> -->

                          <button type="button" class="btn btn-primary"
                          *ngIf="displaySaveButton('VisitPurposePlus')"
                          (click)="executeHomeFieldServiceCreateUpdate('VisitPurposeDetail')">
                          <i class="fa fa-save"></i> &nbsp; Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngFor="let purposeItem of allOtherHFSList;let index=index;">
                  <app-panel-purpose-detail *ngIf="purposeItem.hfServiceReferenceId"
                  [HFMasterServiceId]="purposeItem.hfServiceId"
                  [HFServiceConnectedId]="purposeItem.hfServiceConnectedId"
                  [PrevSectionDetails]="previousVehicleDetails()"
                  [MasterCompleted]="f.HFServiceStatus.value == 'Completed'"
                  [MasterStationID]="f.HFServiceStationId.value"
                  [isLastAdded]="allOtherHFSList.length == (index +1)"
                  (SaveEvent)="onPanelSave($event)"
                  [LastDepartureDate]="f.HFServicePTHMDepartureTime.value"
                  #panelPurposeDetailComponent
                  ></app-panel-purpose-detail>

                  <app-panel-otherPurpose-detail *ngIf="purposeItem.otherId"
                  [HFMasterServiceId]="purposeItem.hfServiceId"
                  [OtherId]="purposeItem.otherId"
                  (SaveEvent)="onOtherSectionSave($event)"
                  [isLastAdded]="allOtherHFSList.length == (index +1)"
                  [MasterCompleted]="f.HFServiceStatus.value == 'Completed'"
                  #panelOtherSectionDetailComponent
                  ></app-panel-otherPurpose-detail>
<!--
                  [HFSStationId]="purposeItem.childHFServiceStationId"
                  [MRMHomeStationName]="purposeItem.childDialysisStationName"
                  [HFServiceVisitPurpose]="purposeItem.childVisitPurpose" -->
              </div>

              <div class="clearfix"></div>
              <div class="box-body box ibox box-info">
                <div class="panel panel-default margin-bottom-none">
                  <div class="panel-heading"
                    [ngClass]="{'panel-heading-blue': isBluePanelVisitPurposeDetail==true,'panel-heading': isBluePanelVisitPurposeDetail==false}"
                    role="tab">
                    <h4 class="panel-title row">
                      <div class="col-sm-10 hfspanel" style="cursor:pointer" (click)="ExpandSection('VisitPurposeDetail')">
                        <a class="collapsed" data-parent="#accordion" [attr.aria-expanded]="isCollapsed.VisitPurposeDetail"
                          aria-controls="HFS_VisitPurposeDetailRef">
                          <div class="box-header with-border" style="padding: 6px 0px;">
                            <h3 class="box-title container">Return Details
                              
                            </h3>
                          </div>
                        </a>
                      </div>
                      <div class="col-sm-2  inline panel-header-icons-end" style="text-align:right">
                        <!-- <button style="display: inline-block;cursor: pointer;" tooltip="Add Return Detail"
                          (click)="OpenReturnDetail()"
                          *ngIf="isAdditionalAddReturn"
                          class="btn btn-primary  no-print btn-label-left center-block btn-xs" type="button">
                          <span><i class="fa fa-plus"></i></span>
                        </button> -->

                        <button type="button" class="btn btn-primary homeFieldBtn"
                          *ngIf="isAdditionalAddReturn && !isAnyPanelEnable"
                          (click)="OpenReturnDetail()">
                          <i class="fa fa-hospital-o"></i> &nbsp; Return Detail</button>
                          <i class="fa fa-check panel-header-icon-success"
                                *ngIf="f.HFServiceReturnDetailsEnteredOn.value"></i>        
                      </div>
                    </h4>
                  </div>
  
                  <div id="HFS_VisitPurposeDetail" [ngbCollapse]="!isCollapsed.VisitPurposeDetail" class="panel-collapse collapse"
                      role="tabpanel" aria-labelledby="HFS_VisitPurposeDetail">
                    <div class="box-body">
                      <div class="row">
                         <div *ngIf="ReturnDetailsList && ReturnDetailsList?.length > 1">
                          <div class="col-sm-12" *ngIf="getReturnList()">
                            <div *ngFor="let item of ReturnDetailsList; let index=index;" class="panel panel-default mb-2 col-sm-3" style="margin-left:10px;padding-left: 0px !important;padding-right: 0px !important;">
                              <div style="background-color: lightgray; padding: 4px 8px;text-align: center;">
                                <label style="color: black; margin: 0;">T{{ index + 1 }}</label>
                              </div>
                            <div class="panel-body">
                              <div class="mb-1"><label class="control-label fixed-label">End Time:</label> {{item.hfServiceReturnVehicleEndTime | date:'dd/MM/yyyy HH:mm'}}</div>
                              <div class="mb-1"><label class="control-label fixed-label">End KM:</label> {{item.hfServiceReturnVehicleEndedKM}}</div>
                              <div class="mb-1"><label class="control-label fixed-label">Fuel Added:</label> {{item.hfServiceFuelAdded}}</div>
                              <div class="mb-1"><label class="control-label fixed-label">Company:</label> {{item.hfServiceFuelCompany}}</div>
                              <div class="mb-1"><label class="control-label fixed-label">Amount:</label> {{item.hfServiceFuelAmount | currency:"CAD":"symbol-narrow"}}</div>
                              <div class="mb-1"><label class="control-label fixed-label">Payment By:</label> {{item.hfServiceFuelPaymentBy}}</div>
                               <div class="text-center">
                                <button *ngIf="item.hfServiceFuelReceiptPath"
                                        class="btn btn-primary btn-xs"
                                        (click)="openImageDialog(item.hfServiceFuelReceiptPath)">
                                  <i class="fa fa-file"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          </div>
                         </div>
                        <div class="col-sm-9">
                          <notes
                            #notesReturnDetails
                            (addNoteClick)="executeHomeFieldServiceCreateUpdate('ReturnDetail', true, (f.HFServiceStatus.value == 'Completed' && f.HFServiceReturnDetailsEnteredOn.value))">
                          </notes>

                          <attachment [category]="'homefieldreturn_detail'"  #attachmentReturnDetails id="attachmentReturnDetails"
                                      (RaiseError)="AttachmentError($event)">
                          </attachment>

                          <div class="text-right mt-2">
                            <button type="button" class="btn btn-primary"
                                    *ngIf="displaySaveButton('ReturnDetail')"
                                    (click)="executeHomeFieldServiceCreateUpdate('ReturnDetail')">
                              <i class="fa fa-save"></i> &nbsp; Save
                            </button>
                          </div>
                        </div>

                          <div class="col-sm-3" *ngIf="!ReturnDetailsList || ReturnDetailsList.length <= 1">
                          <div *ngFor="let item of ReturnDetailsList" class="panel panel-default mb-2">
                            <div class="panel-body">
                              <div class="mb-1"><label class="control-label fixed-label">End Time:</label> {{item.hfServiceReturnVehicleEndTime | date:'dd/MM/yyyy HH:mm'}}</div>
                              <div class="mb-1"><label class="control-label fixed-label">End KM:</label> {{item.hfServiceReturnVehicleEndedKM}}</div>
                              <div class="mb-1"><label class="control-label fixed-label">Fuel Added:</label> {{item.hfServiceFuelAdded}}</div>
                              <div class="mb-1"><label class="control-label fixed-label">Company:</label> {{item.hfServiceFuelCompany}}</div>
                              <div class="mb-1"><label class="control-label fixed-label">Amount:</label> {{item.hfServiceFuelAmount | currency:"CAD":"symbol-narrow"}}</div>
                              <div class="mb-1"><label class="control-label fixed-label">Payment By:</label> {{item.hfServiceFuelPaymentBy}}</div>
                               <div class="text-center">
                                <button *ngIf="item.hfServiceFuelReceiptPath"
                                        class="btn btn-primary btn-xs"
                                        (click)="openImageDialog(item.hfServiceFuelReceiptPath)">
                                  <i class="fa fa-file"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                     
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div class="clearfix"></div>
              <div class="box-body box ibox box-info">
                <div class="panel panel-default margin-bottom-none">
                  <div class="panel-heading"
                    [ngClass]="{'panel-heading-blue': isBluePanelReturnDetail==true,'panel-heading': isBluePanelReturnDetail==false}"
                    role="tab">
                    <h4 class="panel-title row" style="cursor:pointer"  (click)="ExpandSection('ReturnDetail')">
                      <div class="col-sm-10 hfspanel">
                      <a class="collapsed" data-parent="#accordion" [attr.aria-expanded]="isCollapsed.ReturnDetail"
                        aria-controls="HFS_ReturnDetailRef">
                        <div class="box-header with-border"  style="padding: 6px 0px;">
                          <h3 class="box-title container">Time Summary
                          </h3>
                        </div>
                      </a>
                      </div>
                        <div class="col-sm-2 panel-header-icons-end inline" style="text-align: right;">
                        <i class="fa fa-refresh panel-header-refresh"></i>
                    </div>
                    </h4>
                  </div>

                  <div id="HFS_ReturnDetail" [ngbCollapse]="!isCollapsed.ReturnDetail" class="panel-collapse collapse"
                    role="tabpanel" aria-labelledby="HFS_ReturnDetail">
                    <div class="box-body">
                      <div class="box-row col-sm-12">
                        <div class="col-sm-4">
                          <label class="control-label col-sm-8">Total Tech(s) Time (Billable):</label>
                          <div class="col-sm-4">
                            <input class="form-control" value="{{ (f.HFServiceStatus.value == 'Completed') ? totalTechTime : 'N/A'}}" disabled="disabled">
                          </div>
                        </div>
                        <div class="col-sm-5">
                          <label class="control-label col-sm-8">Total Tech(s) Time (Non-Billable):</label>
                          <div class="col-sm-3">
                            <input class="form-control" value="N/A" disabled="disabled">
                          </div>
                        </div>
                        <div class="col-sm-3">
                          <label class="control-label col-sm-8">Total KMs:</label>
                          <div class="col-sm-4">
                            <input class="form-control" value="{{TotalCalculatedKMs}}" disabled="disabled">
                          </div>
                        </div>
                      </div>

                      <div class="box-row col-sm-12" style="border:1px solid lightgray;padding: 10px">
                        <div class="row col-sm-12">
                          <!-- <p class="InnerPurposeHFSHeader">1st Visit:</p> -->
                          <label class="control-label col-sm-12" style="font-weight: bold;font-size:18px;text-align: left;">Visit Time Summary Details:</label>
                        </div>

                      <!-- <div class="col-sm-3">
                          <label class="control-label col-sm-12" style="display: none">Station:</label>
                          <label class="control-label col-sm-12">Total Prep Time:</label>
                          <label class="control-label col-sm-12">Total Time at Pt. Home:</label>
                          <label class="control-label col-sm-12">Total Travelling Time:</label>
                          <label class="control-label col-sm-12">Total Testing Time:</label>
                        </div>

                      <div class="col-sm-1">
                        <label class="col-sm-12" style="text-align: center;font-weight: normal;padding-top: 6px !important;display: none">{{MRMHomeStationName}} </label>
                        <label class="col-sm-12" style="text-align: center;font-weight: normal;padding-top: 6px !important;">{{prepTimeSummary}}</label>
                        <label class="col-sm-12" style="text-align: center;font-weight: normal;padding-top: 6px !important;">{{travellingTimeSpentAtPtHome}}</label>
                        <label class="col-sm-12" style="text-align: center;font-weight: normal;padding-top: 6px !important;">{{totalTravellingTime}}</label>
                        <label class="col-sm-12" style="text-align: center;font-weight: normal;padding-top: 6px !important;">{{totalTechTestingTime}}</label>
                      </div> -->

                    <div class="row col-sm-12" style="margin-top: 10px;">
                        <!-- Total Prep Time -->
                        <div class="col-sm-3">
                          <div style="display: flex; align-items: center;">
                            <label class="control-label" style="margin-right: 5px;">Total Prep Time:</label>
                            <span>{{ prepTimeSummary }}</span>
                          </div>
                        </div>

                        <!-- Total Time at Pt. Home -->
                        <div class="col-sm-3">
                          <div style="display: flex; align-items: center;">
                            <label class="control-label" style="margin-right: 5px;">Total Time at Pt. Home:</label>
                            <span>{{ travellingTimeSpentAtPtHome }}</span>
                          </div>
                        </div>

                        <!-- Total Travelling Time -->
                        <div class="col-sm-3">
                          <div style="display: flex; align-items: center;">
                            <label class="control-label" style="margin-right: 5px;">Total Travelling Time:</label>
                            <span>{{ totalTravellingTime }}</span>
                          </div>
                        </div>

                        <!-- Total Testing Time -->
                        <div class="col-sm-3">
                          <div style="display: flex; align-items: center;">
                            <label class="control-label" style="margin-right: 5px;">Total Testing Time:</label>
                            <span>{{ totalTechTestingTime }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-1" *ngFor="let panelChild of panelChildrens ;let index=index" [hidden]="f.HFServiceStatus.value != 'Completed'" style="min-width: 12%;">
                          <label class="col-sm-12" style="text-align: center;font-weight: normal;padding-top: 6px !important;"><b>{{panelChild.MRMHomeStationName}}</b></label>
                        <label class="col-sm-12" style="text-align: center;font-weight: normal;padding-top: 6px !important;">{{panelChild.prepTimeSummary}}</label>
                        <label class="col-sm-12" style="text-align: center;font-weight: normal;padding-top: 6px !important;">{{panelChild.travellingTimeSpentAtPtHome}}</label>
                        <label class="col-sm-12" style="text-align: center;font-weight: normal;padding-top: 6px !important;">{{panelChild.totalTravellingTime}}</label>
                        <label class="col-sm-12" style="text-align: center;font-weight: normal;padding-top: 6px !important;">{{panelChild.totalTechTestingTime}}</label>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="clearfix"></div>
              <div class="box-body box ibox box-info">
                <div class="panel panel-default margin-bottom-none">
                  <div class="panel-heading" style="padding:6px 0px;"
                    [ngClass]="{'panel-heading-blue': isBluePanelSection7==true,'panel-heading': isBluePanelSection7==false}"
                    role="tab">
                    <h4 class="panel-title" style="cursor:pointer" (click)="ExpandSection('Section7')">
                      <a class="collapsed" data-parent="#accordion" [attr.aria-expanded]="isCollapsed.Section7"
                        aria-controls="HFS_Section7Ref">
                        <div class="box-header with-border"  style="padding: 6px 0px;">
                          <h3 class="box-title container">Notes & Parts Summary
                            <span><i class="fa fa-plus-square faplusicon" *ngIf="(notesVisitPurpose && notesVisitPurpose.NoteList.length > 0)  ||
                              (notesVisitPurposePlus && notesVisitPurposePlus.NoteList.length > 0) ||
                                         (notesVisitPrep && notesVisitPrep.NoteList.length > 0) ||
                                         (notesVisitVehicles && notesVisitVehicles.NoteList.length > 0) ||
                                         (notesReturnDetails && notesReturnDetails.NoteList.length > 0)"></i></span>

                          </h3>
                        </div>
                      </a>
                    </h4>
                  </div>

                  <div id="HFS_Section7" [ngbCollapse]="!isCollapsed.Section7" class="panel-collapse collapse"
                    role="tabpanel" aria-labelledby="HFS_Section7">
                    <div class="box-body">
                      <div class="box-row col-sm-12">
                        <div class="text-center"><b>NOTE SUMMARY</b><b *ngIf="allNotesList.length == 0">- N/A</b></div>
                        <div *ngIf="allNotesList.length > 0">
                          <table width="100%" style="width:100%;table-layout: fixed;" align="center" class="">
                              <tr>
                                <th class="InnerTableHead" style="width:10%">Date</th>
                                <th class="InnerTableHead" style="width:7%">Time</th>
                                <th class="InnerTableHead" style="width:10%">Tech</th>
                                <th class="InnerTableHead" style="width:25%;">Section</th>
                                <th class="InnerTableHead" style="width:55%;">Note</th>
                              </tr>
                            <tbody>
                              <tr *ngFor="let item of allNotesList ;let index=index" style="text-align: center;">
                                <td>{{item.createdOn | date:'dd/MM/yyyy'}}</td>
                                <td>{{item.createdOn | date:'HH:mm'}}</td>
                                <td>{{item.createdbyname}} </td>
                                <td style="word-wrap: break-word;">{{item.moduleName}}
                                </td>
                                <td align="left" width="auto" >
                                  <div style="word-wrap: break-word;" [innerHTML]="item.description">
                                  </div>
                              </td>

                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="box-row col-sm-12">
                        <div class="text-center"><b>PARTS SUMMARY</b><b *ngIf="PartTrans.length == 0">- N/A</b></div>
                        <div *ngIf="PartTrans.length > 0">
                          <table style="width:100%" align="center" class="table InnerTable table-responsive">
                              <tr>
                                <th class="InnerTableHead" style="width:10%">Date</th>
                                <th class="InnerTableHead" style="width:10%">Time</th>
                                <th class="InnerTableHead" style="width:10%">Tech</th>
                                <th class="InnerTableHead" style="width:15%">
                                  Part ID
                                </th>
                                <th class="InnerTableHead" style="width:40%">
                                  Part Description
                                </th>
                                <th class="InnerTableHead" style="width:7.5%">
                                  Part Qty.
                                </th>
                                <th class="InnerTableHead" style="width:7.5%">
                                  Part Cost
                                </th>
                              </tr>
                            <tbody>

                              <tr *ngFor="let item of PartTrans;let index=index;">
                                <td>
                                  {{item.createdOn | date:'dd/MM/yyyy'}} </td>

                                <td>
                                  {{item.createdOn | date:'HH:mm'}} </td>
                                <td>
                                  {{item.createdByName}}</td>
                                <td>
                                  {{item.PartCode}}
                                </td>
                                <td>
                                  {{item.PartDescription}}
                                </td>

                                <td>
                                  {{item.quantity}}
                                </td>
                                <td>
                                  {{(item.PartCost * item.quantity | currency:"CAD":"symbol-narrow") }}
                                </td>

                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</form>
